import GDPR from "./GDPR.vue";

export default {
  install(Vue) {
    //Modul komponensek regisztrálása
    Vue.component("fp-gdpr", GDPR);
  },
};
